import { render, staticRenderFns } from "./ResetPasswordLinkSentMessage.vue?vue&type=template&id=5ac1fff7&scoped=true"
import script from "./ResetPasswordLinkSentMessage.vue?vue&type=script&lang=js"
export * from "./ResetPasswordLinkSentMessage.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordLinkSentMessage.vue?vue&type=style&index=0&id=5ac1fff7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac1fff7",
  null
  
)

export default component.exports